import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { UserState } from 'app/projects/user/src/lib/models/user.state';

@Injectable()
export class UserTeamGuard  {
    constructor(private _store: Store) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const profile = this._store.selectSnapshot(UserState.getMyInfo);

        if (profile.inTeam) {
            return of(true);
        }

        this._store.dispatch(new Navigate(['/modules']));

        return of(false);
    }
}
